module.exports = { id: "woman-frame", url: "/build/app/img/symbols.svg#woman-frame", viewBox: "", toString: function() { return this.url; } };